import { ECurrency } from '@pushflow/database/prisma/types/enums'
import { useAtomValue } from 'jotai'
import { useTranslation } from 'react-i18next'
import tonIcon from '../../../assets/images/currencies/ton.png'
import usdtTetherIcon from '../../../assets/images/currencies/usdt_tether.png'
import { useFormatToBigBlindMultiple } from '../../../hooks'
import { userSettingsAtom } from '../../../store/atoms'
import { AnimatedNumber } from '../../atoms'
import * as styles from './index.css'

export const Money = (
  props: {
    children: number
    withIcon?: boolean
    iconFirst?: boolean
    currency?: ECurrency
    isAnimated?: boolean
  } & (
    | {
        inBigBlinds?: false
        bigBlind?: number
      }
    | {
        inBigBlinds: true
        bigBlind: number
      }
  ),
) => {
  const { t } = useTranslation()
  const userSettings = useAtomValue(userSettingsAtom)

  const { formatToBigBlinds } = useFormatToBigBlindMultiple(props.bigBlind || 0)

  const inBigBlinds = props.inBigBlinds ?? userSettings.valuesInBigBlinds
  const value = inBigBlinds ? formatToBigBlinds(props.children) : props.children

  const renderValue =
    props.isAnimated === false ? (
      value
    ) : (
      <AnimatedNumber>{value}</AnimatedNumber>
    )

  if (inBigBlinds) {
    return (
      <>
        {renderValue}&nbsp;{t('table.label.bb')}
      </>
    )
  }

  if (props.withIcon && props.currency) {
    const sourcesByCurrency: Partial<Record<ECurrency, string>> = {
      [ECurrency.COIN]: '/logo/minimal.png',
      [ECurrency.USDT]: usdtTetherIcon,
      [ECurrency.TON]: tonIcon,
    }
    const imgSrc = sourcesByCurrency[props.currency]
    if (imgSrc) {
      return (
        <span
          className={
            props.iconFirst
              ? styles.blockWithImageReverse
              : styles.blockWithImage
          }
        >
          {renderValue}
          <img
            src={imgSrc}
            alt={props.currency}
            className={styles.currencyImage}
          />
        </span>
      )
    }
  }
  return renderValue
}
